/**
 * External dependencies
 */
export default class Terminal {
    constructor(cscom) {
        if (!(this instanceof Terminal)) {
            return new Terminal(cscom);
        }
        this.cscom = cscom;
    }

    getTerminals() {
        return this.cscom.req.get('/user-site-api/user-terminal-details');
    }
}
